// extracted by mini-css-extract-plugin
module.exports = {"cell":"_5b10bb2305--cell--kpXuR","cell--fullwidth":"_5b10bb2305--cell--fullwidth--k8B9Q","cell--dragging":"_5b10bb2305--cell--dragging--FLml1"};